<template>
    <div class="exam-result" v-loading="loading">
        <div v-if="examData">
            <div class="exam-result-title">
                <div> </div>
                <div><h3>{{examData.exam.exam.exam}}</h3></div>
                <div class="exam-result-title-p"><button @click="anewExam" class="p-pointer">重新考试</button></div>
            </div>
            <exam-head :data="examData"></exam-head>
            <div style="margin-top:36px;">
                <div v-for="(item,index) in examData.exam.questionSort" :key="index">
                    <exam-result :index="index+1" :data="item" :examData="examData">
                        <el-divider v-if="examData.exam.questionSort.length!=index+1"></el-divider>
                    </exam-result>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import examResult from '@p/components/result/exam-result'
import examHead from '@p/components/result/result-head'
export default {
    data(){
        return {
            loading:false,
            examData:'',                    //成绩数据
            examination:'',
        }
    },
    created(){
        this.achievementArchives()
    },
    methods:{
        async achievementArchives(){
            this.loading=true;
            await this.$http.examination.achievementArchives({exam_id:this.$route.query.exam_id,history_id:this.$route.query.history_id}).then(v=>{
                if(v.status === 200 && v.data.status_code === 200){
                    const examData = v.data.data;
                    this.examData={
                         exam:examData,
                         examHistoryQuestion:JSON.parse(examData['answer']),
                    };
                }
                this.loading=false;
            }).catch(er=>{this.loading=false;})
        },
        //重新考试
        anewExam(){
            this.$router.go(-2)
        },
        //是否可以重新考试
        setAnewExam(v){
            if(!v) return false;
            const examData=v.exam.find(item=>item.id === this.$route.query.exam_id);
            if(!examData) return false;
            let currentTime = new Date();
            let newBegin = new Date(Date.parse(v.apply_begin_date.replace("-","/")));
            let newEnd = new Date(Date.parse(v.apply_of_date.replace("-","/")));
            if((v.max_times-examData.history_count>0 && currentTime > newBegin && currentTime < newEnd)){ //次数，考试时间内
                return v.max_times-examData.history_count;
            }
            return false;
        },
    },
    components:{
        examResult,examHead
    }
}
</script>
<style lang="less" scoped>
.exam-result{
    padding-bottom: 38px;
    &-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
        margin-bottom: 20px;
        >div{
            flex: 1;
        }
        h3{
            color:rgba(51,51,51,1);
            font-size:20px;
            text-align: center;
        }
        &-p{
            font-size:14px;
            color:rgba(64,64,64,1);
            text-align: right;
            span{
                padding: 0 5px;
                color: #F7971E;
            }
            button{
                width:120px;
                height:40px;
                font-size:14px;
                font-weight:400;
                color:rgba(255,255,255,1);
                background:rgba(77,142,246,1);
                border: none;
                border-radius:4px;
                margin-left: 16px;
            }
        }
    }
}
</style>